import $ from 'jquery';
const MODULE_NAME = 'futamidoValidator';
export default angular.module(MODULE_NAME, []).directive('futamidoValidator', function () {
	'ngInject';
	return {
		restrict: 'A',
		require: 'ngModel',
		link: function (scope, element, attrs, ngModelCtrl) {

			ngModelCtrl.$validators.range = function (modelValue) {
				var valid = true;
				if ($.isNumeric(modelValue) && (modelValue < 12 || modelValue > 72)) {
					valid = false;
				}
				return valid;
			};

		}
	};
}).name;



// WEBPACK FOOTER //
// ./source/applications/kalkulator/eszkozkalkulator/validators/futamidovalidator.js